import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ArtworksOfArtist from '@/pages/profile/artists/artworks-of-artist';
import FollowButton from '@/shared-components/buttons/components/FollowButton';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import ArtistVerifiedIcon from '@/shared-components/icons/components/user-profile/ArtistVerifiedIcon';
import Text from '@/shared-components/text/components/Text';

import './styles/Row.css';

export default function Row({ item }) {
  const navigate = useNavigate();
  const [isArtistArtworksOpen, setIsArtistArtworksOpen] = useState(false);
  const [modalQueryData, setModalQueryData] = useState({ cacheKey: '', endpoint: '' });

  const artistModalData = useMemo(() => {
    if (item?.user_type !== 'gallery_artist') return null;
    return {
      ...item?.gallery_artist,
      _id: item?._id,
      user_type: 'gallery_artist',
      artist_name: item?.artist_name || item?.user_name || item?.gallery_artist?.artist_name || '',
      artist_username: item?.artist_username || item?.user_username || item?.gallery_artist?.artist_username || '',
    };
  }, [item]);

  const openArtistArtworks = () => {
    if (!artistModalData?._id) return;
    setModalQueryData({
      cacheKey: `artworks_of_${artistModalData._id}_in_search`,
      endpoint: `/galleryartist/${artistModalData._id}/artworks`,
    });
    setIsArtistArtworksOpen(true);
  };

  const handleRowClick = () => {
    if (item?.user_type === 'gallery_artist') {
      openArtistArtworks();
      return;
    }
    if (item?.user_username) {
      navigate(`/user/${item.user_username}`, { state: { from: true } });
    }
  };

  return (
    <>
      <div className="render-inspiring-result__outter">
        <div className="render-inspiring__result" onClick={handleRowClick}>
          <div className="render-inspiring-result__container">
            <UserProfileImage 
              image={item.user_image?.image_id} 
              typeOfProfile={item.user_type} 
              className="render-inspiring-result__image"
            />

            <div className="render-inspiring-result__name-block">
              {
                item.user_type === "collector" ? 
                  <Text
                    className="render-inspiring-result__name-username as-name font-size-small"
                    paragraph>
                    {item.user_username}
                  </Text>
                  : 
                  <>
                    <Text className="render-inspiring-result__name-name font-size-small" paragraph>
                      {item.user_name}
                      {item.user_type === "artist" && item.user_flags.suarteroad_completed ? <ArtistVerifiedIcon className="render-inspiring-result__user-verified-icon"/> : <></>}
                    </Text>

                    {Boolean(item.user_username) && (
                      <Text className="render-inspiring-result__name-username" paragraph extraSmall>
                        @{item.user_username}
                      </Text>
                    )}
                  </>
              }
            </div>

            <div className="render-inspiring-result__action">
              <FollowButton
                userId={item._id}
                followeeType={item?.user_type === 'gallery_artist' ? 'gallery_artist' : 'user'}
                imFollowing={item.im_following}
                isFollowingMe={item.is_following_me}
                className="render-inspiring-result__follow-button"
                userName={item.user_name || item.artist_name || item.user_username}
                userUsername={item.user_username || item.artist_username || ''} />
            </div>
          </div>
        </div>
      </div>
      {artistModalData && (
        <ArtworksOfArtist
          open={isArtistArtworksOpen}
          close={() => setIsArtistArtworksOpen(false)}
          artist={artistModalData}
          profileData={artistModalData}
          internal={false}
          showHeader={false}
          cacheKey={modalQueryData.cacheKey}
          queryEndpoint={modalQueryData.endpoint}
        />
      )}
    </>
  );
}
